import { HttpClient } from "../HttpClient";

export const PutUpdateSubscription = async (id, formData) => {
  try {
    console.log("🔍 PutUpdateSubscription id:", id);
    console.log("🔍 PutUpdateSubscription - FormData entries:");
    for (let [key, value] of formData.entries()) {
      console.log(`  ${key}:`, value instanceof File ? `File(${value.name})` : value);
    }
    
    const { data } = await HttpClient.put(`api/subscriptions/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    console.log("✅ PutUpdateSubscription response:", data);
    return data;
  } catch (err) {
    console.error("❌ PutUpdateSubscription error:", err);
    return Promise.reject(err);
  }
};
// export const PutUpdateSubscription = async (id, formData) => {
//   try {
//     const { data } = await HttpClient.put(`api/subscriptions/${id}`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
